import { DocumentStatus } from "./data"

export class UserKycValidate {
    companyDetails: KycDocumentDetails
    directorDetails: KycDocumentDetails;
    contactPersonDetails: KycDocumentDetails;
    ownershipDetails: KycDocumentDetails;
    internationalBDetails: KycDocumentDetails;
    relatedEntityDetails: KycDocumentDetails;
    localBranchDetails: KycDocumentDetails;
    bankAccountDetails: KycDocumentDetails;
    transactionDetails: KycDocumentDetails;
    complianceDetails: KycDocumentDetails;
    uploadFiles: KycDocumentDetails;

    constructor() {
        this.companyDetails = new KycDocumentDetails();
        this.directorDetails = new KycDocumentDetails();
        this.contactPersonDetails = new KycDocumentDetails();
        this.ownershipDetails = new KycDocumentDetails();
        this.internationalBDetails = new KycDocumentDetails();
        this.relatedEntityDetails = new KycDocumentDetails();
        this.localBranchDetails = new KycDocumentDetails();
        this.bankAccountDetails = new KycDocumentDetails();
        this.transactionDetails = new KycDocumentDetails();
        this.complianceDetails = new KycDocumentDetails();
        this.uploadFiles = new KycDocumentDetails();
    }
}

export class KycDocumentDetails {
    status: DocumentStatus
    comment: UserKycValidateData[] = [];
    log: UserKycValidateData[] = [];


    constructor() {
        this.status = new DocumentStatus();
    }
}

export class UserKycValidateData {
    class: UserKycValidateDataClass;
    admin: UserKycValidateDataAdmin;
    comment: string;
    time: UserKycValidateDataTime;

    constructor() {
        this.class = new UserKycValidateDataClass();
        this.admin = new UserKycValidateDataAdmin();
        this.time = new UserKycValidateDataTime();
    }
}

export class UserKycValidateDataClass {
    name: string;
    id: number;
};

export class UserKycValidateDataAdmin {
    ref: number;
    username: string;
    nickName: string;
    lastName: string;
    firstName: string;
    email: string;
}

export class UserKycValidateDataTime {
    label: string;
    created: string;
    lastModified: string;
}